import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';

export function NotFoundPage() {
  const t = useTranslations('pages.not-found');

  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <EmptyState
        title={t('title')}
        description={t('body')}
        action={
          <Button variant="secondary" asChild>
            <Link to="/">{t('back-to-home')}</Link>
          </Button>
        }
      />
    </main>
  );
}
